const usingServiceAdvantage = {
  en: {
    title: 'The Best Pizza POS System',
    desc: 'Simple, personalized orders, and speedy delivery.',
    items: [
      {
        title: 'A POS perfect for pizza lovers',
        image: `${process.env.ASSETS_PREFIX}/businesstype/pizza-chef-making-pizza-in-restaurant.jpg`,
        items: [
          {
            desc: 'All-in-one interface to manage all orders, toppings, sales, and payments.',
          },
          {
            desc: 'Easily view all orders from dine-in, take-out, delivery, and your website all in one place!',
          },
          {
            desc: 'Combine checks from different tables, split bills, or combine bills with a few clicks.',
          },
        ],
      },
      {
        title: 'Fresh Tech for Fresh Service ',
        image: `${process.env.ASSETS_PREFIX}/businesstype/pizza-for-takeout-and-delivery.jpg`,
        items: [
          {
            desc: 'Enhance efficiency and order precision by seamlessly integrating with essential delivery services.',
          },
          {
            desc: 'Make menu updates from any terminal at your restaurant, at anytime!',
          },
          {
            desc: 'Easily manage menu availability with item countdowns for dine-in, take-out, delivery, and website orders.',
          },
        ],
      },
      {
        title: 'Reporting & Analytics',
        image: `${process.env.ASSETS_PREFIX}/businesstype/fresh-margerita-pizza.jpg`,
        items: [
          {
            desc: 'Easily manage your team across timesheets and schedules.',
          },
          {
            desc: 'Automate tip distribution and manage the share by sales category or by total tips',
          },
          {
            desc: 'Customized reports for restaurant performance and sales reports, accessible from any device.',
          },
        ],
      },
    ],
  },
  zh: {
    title: 'Chowbus披萨店点餐系统是您的首选',
    desc: '简单，个性化的订单，快速的交货。',
    items: [
      {
        title: '更简单的订单制作',
        image: `${process.env.ASSETS_PREFIX}/businesstype/pizza-chef-making-pizza-in-restaurant.jpg`,
        items: [
          {
            desc: '轻松更换馅料，并根据尺寸和定制化要求自动调整附加费用',
          },
          {
            desc: '通过设置最大接纳订单数限定高峰时段的接单数量',
          },
          {
            desc: '披萨店点餐系统帮助您准确备餐',
          },
          {
            desc: '打印并贴上标签，易于识别和订单跟踪',
          },
        ],
      },

      {
        title: '更快速的送餐速度',
        image: `${process.env.ASSETS_PREFIX}/businesstype/pizza-for-takeout-and-delivery.jpg`,
        items: [
          {
            desc: '集成近50家外卖平台，一站式管理所有外卖订单，订单直达厨房',
          },
          {
            desc: '在Chowbus POS后台查看所有平台的外卖收入，直接分析数据表现',
          },
          {
            desc: '餐厅可以提供餐厅网页下单选项，Chowbus提供网站设计和配送服务',
          },
        ],
      },
      {
        title: '更细分的数据报表',
        image: `${process.env.ASSETS_PREFIX}/businesstype/fresh-margerita-pizza.jpg`,
        items: [
          {
            desc: '通过每日数据概览随时随地了解营业额和成本数据',
          },
          {
            desc: '从数据分析中快速得知高销量的类目及餐品',
          },
          {
            desc: '强大的报表系统赋能您的数据决策',
          },
        ],
      },
    ],
  },
};

export default usingServiceAdvantage;
